export const projectileConfig = {
    DEBUG: {
        DRAW_COLLIDER: false,

        // Show your true authoritatiive server projectiles (that are otherwise predicted on your client and therefore hidden)
        DRAW_SERVERSIDE_PROJECTILES_DURING_PREDICTION: false
    }
};
